import React from 'react';
import { auditTime } from 'rxjs';

import {
  trackChangesWhenInactive,
  useUnderEditContext,
} from '@neptune/shared/common-business-logic';

import { getEntitiesNotificationStream } from './entity-notifications';

export function useProjectEntitiesUpdates(projectId: string | undefined, callback: () => void) {
  const { underEdit$ } = useUnderEditContext();

  React.useEffect(() => {
    if (!projectId) {
      return;
    }

    const subscription = getEntitiesNotificationStream(projectId)
      .pipe(auditTime(10_000), trackChangesWhenInactive(underEdit$))
      .subscribe(() => callback());

    return () => subscription.unsubscribe();
  }, [callback, projectId, underEdit$]);
}
